import React, { FC, useState } from 'react';
import styles from '../login/styles/password-reset-success.scss';
import loginStyles from '../login/styles/login.scss';
import { Icon, Snackbar, Spinner } from 'shamrock-clover-ui';
import { TargetPayload } from './passwordResetScreens';
import sentinelService from '../../services/sentinel.service';
import { useSnackBarState } from './utils';
import { useTranslation } from 'react-i18next';

interface PasswordResetFromProps {
  target: TargetPayload;
  backToLogin: () => void;
}

export const PasswordResetSent: FC<PasswordResetFromProps> = ({ target: { target, email, phone }, backToLogin }) => {
  const [sending, setSending] = useState(false);
  const [snackBarProps, setSnackBarProps] = useSnackBarState();
  const {t} = useTranslation('common', { keyPrefix: 'authentication'});
  const {t: tCommon} = useTranslation();
  const sendResetLink = async () => {
    setSending(true);
    try {
      await sentinelService.forgotPassword({ email, sendSms: target === 'sms' });
      setSnackBarProps({
        open: true,
        message: target === 'email' ? t('password_reset_success.email_sent') : t('password_reset_success.sms_sent'),
        variant: 'success',
      });
    } catch (error) {
      console.log('Temp logging of error:', error);
      setSnackBarProps({
        open: true,
        message: tCommon('something_went_wrong_please_try_again_later'),
        variant: 'error',
      });
    } finally {
      setSending(false);
    }
  };
  const Verbiage = target === 'email' ? EmailVerbiage : PhoneVerbiage;
  const payload = target === 'email' ? email : phone;
  return (
    <div className={styles.contentBox}>
      {sending && (
        <div className={loginStyles.spinnerContainer}>
          <Spinner />
        </div>
      )}
      <div className={styles.title}>
        <Icon icon="chevronLeft" size="16" onClick={backToLogin} />
        <h2>{t('password_reset_title')}</h2>
      </div>
      <div className={styles.verbiage}>
        <Verbiage payload={payload} resend={sendResetLink} />
      </div>
      <Snackbar {...snackBarProps}/>
    </div>
  );
};

type VerbiageProps = {
  payload: string,
  resend: () => void
};

const EmailVerbiage: FC<VerbiageProps> = ({ payload: email, resend }) => {
  const {t} = useTranslation('common', { keyPrefix: 'authentication' });
  return (
    <>
      <p>
        <strong>
          {t('password_reset_success.sent_email_verbiage.title')}&nbsp;
          {email}
        </strong>
      </p>
      <p>{t('password_reset_success.sent_email_verbiage.body')}</p>
      <p>
        {t('password_reset_success.sent_email_verbiage.resend_prefix')}
        <button className={styles.inlineButton} onClick={resend}>
          {t('password_reset_success.sent_email_verbiage.resend_text')}
        </button>
      </p>
    </>
  );
};

const PhoneVerbiage: FC<VerbiageProps> = ({payload: phone, resend}) => {
  const {t} = useTranslation('common', { keyPrefix: 'authentication' });
  return (
    <>
      <p>
        <strong>
          {t('password_reset_success.phone_reset_verbiage.title')} *****{phone}.
        </strong>
      </p>
      <p>{t('password_reset_success.phone_reset_verbiage.body')}</p>
      <p>
        {t('password_reset_success.phone_reset_verbiage.resend_prefix')}{' '}
        <button className={styles.inlineButton} onClick={resend}>
          {t('password_reset_success.phone_reset_verbiage.resend_text')}
        </button>
      </p>
    </>
  );
};


